module.exports = __webpack_public_path__ + "img/2018太和药聚多推介会.b92145bd.jpg";